import React, { useEffect, useState, useRef } from "react";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";

import { DialogDelete } from "../../../components/DialogService/DialogService";
import { FooterButtonCenter } from "../../../components/FooterButton/FooterButton";
import { Loading } from "../../../components/Loading/Loading";
import { dataUserSession } from "../../../utilities/dataSession";
import { useHistory } from "react-router-dom";
import { DialogOpenReport } from "../../../components/DialogService/DialogService";
import DialogGenReport from "../../../components/DialogReport/DialogGenReport";
import ValidateService from "../../../components/ValidateService/ValidateService";

// PAGE
import P233List from "./P233List";

// SERVICE
import { pP2List } from "../../../service/200/P233Service";
import { pP2Print } from "../../../service/200/P234Service";

// Report
import { pdfRPT234 } from "../../../Report/234/RPT234PDF";
import { RPT234Word } from "../../../Report/234/RPT234Word";

export default function P233() {
    const history = useHistory();

    const toast = useRef(null);
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [loading, setLoading] = useState(false);

    // DIALOG PDF
    const [dialogPDF, setDialogPDF] = useState(false);
    const [dialogReport, setDialogReport] = useState({ dialog: false, show: false });
    const [dataRPT, setDataRPT] = useState([]);

    // SEARCH
    const [searchData, setSearchData] = useState({ contractNo: "", userId: dataUserSession() ? dataUserSession().userId : "" });

    // DATA
    const [dataTable, setDataTable] = useState([]);
    const [errData, setErrData] = useState(null);

    useEffect(() => {
        if (dataUserSession()) {
            if (history.location.state) {
                setSearchData({
                    ...searchData,
                    ...history.location.state,
                    userId: dataUserSession().userId,
                });
            } else {
                // FOR Test

                // setSearchData({
                //     contractNo: "ป.16-1/64",
                //     userId: "s16",
                //     routeNo: 1,
                //     contractorName: "",
                //     supervisorName: "",
                // });

                history.push("/208");
            }
        } else {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        if (searchData.contractNo !== "") onGetPP2List();
    }, [searchData]);

    const onGetPP2List = () => {
        setLoading(true);
        pP2List(searchData).then(
            (res) => {
                setLoading(false);
                if (res != undefined) {
                    let temp = [];
                    let index = 0;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataTable(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const footerButton = () => {
        const handlerDeleteData = () => {
            setDeleteDialog(false);
        };

        return <FooterButtonCenter onClickOk={() => handlerDeleteData()} onClickCancle={() => setDeleteDialog(false)} />;
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const onExport = (act) => {
        switch (act) {
            case "PDF":
                pdfRPT234(dataRPT, setLoading, setDialogPDF);
                break;

            case "WORD":
                RPT234Word(dataRPT, setLoading);
                break;

            default:
                break;
        }
        setDialogReport({ dialog: false, show: false });
    };

    const handlerLoadDataReport = (req) => {
        setLoading(true);
        pP2Print(req).then(
            (res) => {
                setLoading(false);
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    if (temp.length > 0) {
                        setDataRPT(temp[0]);
                        setDialogReport({ dialog: true, show: false });
                    }
                } else {
                    showMessages(toast, "error", `เกิดข้อผิดพลาด Status Code: ${res.status}`, `${res.message}`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const handlerActionMulti = (rowData) => {
        switch (rowData.status) {
            case "NEW":
                history.push({ pathname: "/233Edit_1", state: { dataSrh: { contractNo: searchData.contractNo, withdrawSeq: 1 } } });
                break;
            case "208":
                history.push({ pathname: "/208" });
                break;

            case "EDIT":
                history.push({ pathname: "/233Edit_2", state: { dataSrh: { contractNo: rowData.data.contractNo, withdrawSeq: rowData.data.withdrawSeq } } });
                break;

            case "PRINT":
                handlerLoadDataReport({ contractNo: rowData.data.contractNo, withdrawSeq: rowData.data.withdrawSeq, userId: searchData.userId });
                break;

            default:
                break;
        }
    };

    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        {/* <h3>P2 ขอเบิกจ่ายเงิน</h3>
                        <hr /> */}
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="contractNo">เลขที่สัญญา</label>
                                <InputText id="contractNo" type="text" value={searchData.contractNo} maxLength="20" disabled={true} />
                            </div>
                            <div className="p-field p-col-12 p-md-2">
                                <div style={{ display: "flex", marginTop: "30px" }}>
                                    <Button
                                        className="p-button-secondary p-button btn-hidden-responsive"
                                        icon="pi pi-arrow-left"
                                        label="กลับหน้าจอหลัก"
                                        onClick={() => {
                                            handlerActionMulti({ status: "208", data: null });
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <hr />
                        <P233List dataTable={dataTable} setActionMulti={handlerActionMulti} />
                    </div>
                </div>
            </div>
            <DialogDelete visible={deleteDialog.open} header="การยืนยัน" modal footer={footerButton()} onHide={() => setDeleteDialog(false)} textContent="คุณต้องการลบข้อมูล ใช่หรือไม่ ?" />
            <DialogGenReport dialog={dialogReport} setDialog={setDialogReport} setExport={onExport} pdf={true} word={true} />
            <DialogOpenReport header="พิมพ์รายงานการประเมิน" dialog={dialogPDF} setDialog={setDialogPDF} />
        </>
    );
}
